import { WidgetSettingsDto } from '@/Domain/api/WIdget/dto/WidgetSetting.dto';
import { WidgetTranslationDto } from '@/Domain/api/WIdget/dto/WidgetTranslation.dto';

export const isFilled = (value: unknown): boolean => {
  if (Array.isArray(value)) return value.some((item) => String(item).trim().length > 0);
  if (typeof value === 'string') return value.trim().length > 0;
  return Boolean(value);
};

// Text fields the widget always exposes, so always translatable.
const ALWAYS_TRANSLATABLE: (keyof WidgetTranslationDto)[] = [
  'header',
  'launcher_label',
  'welcome_message',
  'input_placeholder',
  'background_disclaimer_text',
];

const PRECHAT_TRANSLATABLE: (keyof WidgetTranslationDto)[] = [
  'prechat_header_text',
  'prechat_button_text',
  'prechat_message_text',
];

// The fields that could be translated for THIS widget — the denominator of the
// progress count and the set the editor renders. It's "what applies", not "what
// the primary filled": conversation starters apply only when the primary defines
// any, and the pre-chat fields only when the pre-chat screen is enabled (otherwise
// they'd inflate the count with fields the visitor never sees).
export const getTranslatableFields = (
  primary: WidgetSettingsDto,
): (keyof WidgetTranslationDto)[] => {
  const fields = [...ALWAYS_TRANSLATABLE];
  if (isFilled(primary.conversation_starters)) fields.push('conversation_starters');
  if (primary.prechat_active) fields.push(...PRECHAT_TRANSLATABLE);
  return fields;
};

export type TranslationStatus = {
  filled: number;
  total: number;
  complete: boolean;
};

// How many of this widget's translatable fields the given language has filled in.
// Nothing is required (empty fields fall back to the default); this is informational.
export const getTranslationStatus = (
  primary: WidgetSettingsDto,
  row: WidgetTranslationDto | undefined,
): TranslationStatus => {
  const fields = getTranslatableFields(primary);
  const total = fields.length;
  const source = (row ?? {}) as Record<string, unknown>;
  const filled = row ? fields.filter((field) => isFilled(source[field])).length : 0;
  return { filled, total, complete: total > 0 && filled === total };
};
